export class StatusUnavailableError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'StatusUnavailableError'
    Object.setPrototypeOf(this, StatusUnavailableError.prototype)
  }
}
